// extracted by mini-css-extract-plugin
export default {"wrap":"MobileSection_wrap__McbSB"};